import { I18N_LOCALES, type I18nLocale } from '#/i18n/types/I18nLocale';
import { radiusStringToInt } from '#/modules/search/helpers/radius';

export const SEARCH_RADIUSES: Record<I18nLocale, Record<string, string>> = {
  en: {
    '': 'Default Radius',
    '8000': '5 miles',
    '16000': '10 miles',
    '24000': '15 miles',
    '40000': '25 miles',
    '100000': '60 miles',
    '160000': '100 miles',
    state: 'Entire State',
    country: 'Entire Country',
  },
  es: {
    '': 'Radio por Defecto',
    '5000': '5 Km',
    '10000': '10 Km',
    '15000': '15 Km',
    '25000': '25 Km',
    '60000': '60 Km',
    '100000': '100 Km',
    state: 'Todo el Estado',
    country: 'Todo el País',
  },
  pt: {
    '': 'Automático',
    '5000': '5 Km',
    '10000': '10 Km',
    '15000': '15 Km',
    '25000': '25 Km',
    '60000': '60 Km',
    '100000': '100 Km',
    state: 'Todo o Estado',
    country: 'País Inteiro',
  },
};

export const SEARCH_RADIUS_RADIO_OR_SELECT_OPTIONS: () => Record<
  I18nLocale,
  { label: string; value: string }[]
> = () =>
  I18N_LOCALES.reduce(
    (acc, locale: I18nLocale) => ({
      ...acc,
      [locale]: Object.entries(SEARCH_RADIUSES[locale]).map(
        ([value, label]) => ({
          value,
          label,
        }),
      ),
    }),
    {} as Record<I18nLocale, { label: string; value: string }[]>,
  );

export const SEARCH_RADIUS_AS_INT_RADIO_OR_SELECT_OPTIONS: () => Record<
  I18nLocale,
  { label: string; value: string }[]
> = () =>
  I18N_LOCALES.reduce(
    (acc, locale: I18nLocale) => ({
      ...acc,
      [locale]: Object.entries(SEARCH_RADIUSES[locale]).map(
        ([value, label]) => ({
          value: radiusStringToInt(value),
          label,
        }),
      ),
    }),
    {} as Record<I18nLocale, { label: string; value: string }[]>,
  );
